export function centsToDollars(amount?: number) {
  if (!amount) {
    return 0;
  }
  return amount / 100;
}
